module.exports = __webpack_public_path__ + "static/media/apple_store_badge.57272347.svg";